const S = {
  wrapper: { marginTop:'10px', padding:'40px', border:'3px solid grey', fontFamily:"'Georgia', serif", color:'#1a1a2e', lineHeight:'1.7' },
  h1: { fontSize:'2rem', fontWeight:'700', borderBottom:'3px solid #c0392b', paddingBottom:'8px', marginBottom:'24px', color:'#7B0D0D' },
  h2: { fontSize:'1.3rem', fontWeight:'700', color:'#c0392b', marginTop:'36px', marginBottom:'12px', borderLeft:'4px solid #c0392b', paddingLeft:'10px' },
  p: { marginBottom:'12px', fontSize:'0.97rem' },
  infoBox: { background:'#FEF0F0', border:'2px solid #c0392b', borderRadius:'6px', padding:'16px 20px', margin:'16px 0' },
  infoBoxTitle: { fontWeight:'700', fontFamily:"'Courier New', monospace", fontSize:'0.88rem', color:'#7B0D0D', marginBottom:'8px' },
  infoBoxItem: { fontSize:'0.9rem', margin:'4px 0', paddingLeft:'12px', borderLeft:'2px solid #c0392b' },
  table: { width:'100%', borderCollapse:'collapse', marginBottom:'20px', fontSize:'0.92rem' },
  th: { background:'#c0392b', color:'#fff', padding:'10px 14px', textAlign:'left', fontWeight:'700', fontSize:'0.9rem' },
  tdE: { padding:'10px 14px', borderBottom:'1px solid #f0cece', verticalAlign:'top', background:'#fff5f5' },
  tdO: { padding:'10px 14px', borderBottom:'1px solid #f0cece', verticalAlign:'top', background:'#fff' },
  tdL: { fontWeight:'600', color:'#7B0D0D', whiteSpace:'nowrap', width:'220px' },
  code: { fontFamily:"'Courier New', monospace", fontSize:'0.88rem', whiteSpace:'pre-wrap' },
  dWrap: { margin:'24px 0', background:'#fffafa', border:'1px solid #f0cece', borderRadius:'8px', padding:'20px' },
  dTitle: { fontWeight:'700', fontSize:'0.95rem', color:'#7B0D0D', marginBottom:'12px', textAlign:'center', letterSpacing:'0.02em' },
  dCaption: { fontSize:'0.84rem', color:'#555', textAlign:'center', marginTop:'10px', fontStyle:'italic' },
};

function InfoBox({ title, items }) {
  return (
    <div style={S.infoBox}>
      <div style={S.infoBoxTitle}>{title}</div>
      {items.map((item, i) => <div key={i} style={S.infoBoxItem}>{item}</div>)}
    </div>
  );
}

function Table2({ rows }) {
  return (
    <table style={S.table}>
      <thead><tr>
        <th style={{ ...S.th, width:'220px' }}>Concept</th>
        <th style={S.th}>Explanation / Formula</th>
      </tr></thead>
      <tbody>
        {rows.map(([label, content], i) => (
          <tr key={i}>
            <td style={{ ...(i%2===0?S.tdE:S.tdO), ...S.tdL }}>{label}</td>
            <td style={{ ...(i%2===0?S.tdE:S.tdO), ...S.code }}>{content}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}

// ── Diagram 1: Linear vs Nonlinear Restoring Forces ───────────────
function DiagramRestoringForces() {
  const W = 900, H = 340;
  const PW = (W - 30) / 2;

  const N = 200;
  const xVals = Array.from({ length: N }, (_, i) => -2.5 + i / (N - 1) * 5);

  // Restoring forces
  const linear    = xVals.map(x => x);
  const hardening = xVals.map(x => x + 0.4 * x * x * x);
  const softening = xVals.map(x => x - 0.3 * x * x * x);
  const bilinear  = xVals.map(x => x > 0 ? x * 2.2 : x * 0.7);
  const deadband  = xVals.map(x => Math.abs(x) < 0.6 ? 0 : (x > 0 ? (x - 0.6) * 1.4 : (x + 0.6) * 1.4));

  const ox = 14, oy = 170, ow = PW - 28, oh = 130;
  const toX = v => ox + (v + 2.5) / 5 * ow;
  const toY = v => oy - Math.max(-1.5, Math.min(1.5, v)) / 1.5 * oh * 0.9;

  // Panel 2: potential energy wells
  const ox2 = PW + 40, oy2 = 200, ow2 = PW - 50, oh2 = 160;
  const toX2 = v => ox2 + (v + 2.5) / 5 * ow2;
  const toY2 = v => oy2 - Math.max(0, Math.min(v, 3.5)) / 3.5 * oh2;

  const singleWell = xVals.map(x => 0.5 * x * x);
  const doubleWell = xVals.map(x => -0.5 * x * x + 0.25 * x * x * x * x);
  const asymWell   = xVals.map(x => 0.3 * x * x + 0.15 * x * x * x);

  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Restoring Force Characteristics and Potential Energy Wells</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{ width: '100%', display: 'block' }}>
        <defs>
          <marker id="rf1" markerWidth="6" markerHeight="6" refX="5" refY="3" orient="auto">
            <polygon points="0 0,6 3,0 6" fill="#888" />
          </marker>
        </defs>

        {/* Panel 1: Restoring force vs displacement */}
        <rect x={10} y={10} width={PW} height={H - 20} rx={5} fill="#fff" stroke="#f0cece" />
        <text x={10 + PW / 2} y={28} textAnchor="middle" fontSize="13" fill="#7B0D0D" fontWeight="700">Restoring Force F(x) vs. Displacement x</text>

        {/* Axes */}
        <line x1={ox} y1={oy} x2={ox + ow + 10} y2={oy} stroke="#888" strokeWidth="1.5" markerEnd="url(#rf1)" />
        <line x1={ox} y1={oy + oh * 0.9 + 4} x2={ox} y2={oy - oh * 0.9 - 10} stroke="#888" strokeWidth="1.5" markerEnd="url(#rf1)" />
        <text x={ox + ow + 14} y={oy + 4} fontSize="10" fill="#555">x</text>
        <text x={ox + 4} y={oy - oh * 0.9 - 12} fontSize="10" fill="#555">F</text>

        {/* Zero lines */}
        <line x1={ox} y1={oy} x2={ox + ow} y2={oy} stroke="#f0f0f0" strokeWidth="1" />
        <line x1={toX(0)} y1={oy - oh * 0.9} x2={toX(0)} y2={oy + oh * 0.9} stroke="#f0f0f0" strokeWidth="1" />

        {[
          { ys: linear,    col: '#888',    dash: '6,3', label: 'Linear (k)', lx: 1.4 },
          { ys: hardening, col: '#c0392b', dash: 'none', label: 'Hardening (Duffing+)', lx: 1.1 },
          { ys: softening, col: '#2E75B6', dash: 'none', label: 'Softening (Duffing−)', lx: 1.6 },
          { ys: bilinear,  col: '#e07b00', dash: '4,2', label: 'Bilinear / piecewise', lx: 0.8 },
          { ys: deadband,  col: '#27ae60', dash: '3,2', label: 'Dead-band (clearance)', lx: 0.9 },
        ].map(({ ys, col, dash, label, lx }) => {
          const pts = xVals.map((x, i) => `${toX(x)},${toY(ys[i])}`).join(' ');
          const lxi = Math.round((lx + 2.5) / 5 * (N - 1));
          return (
            <g key={label}>
              <polyline points={pts} fill="none" stroke={col} strokeWidth={col === '#888' ? 1.5 : 2.2} strokeDasharray={dash} />
              <text x={toX(lx) + 4} y={toY(ys[lxi]) - 4} fontSize="9" fill={col} fontWeight="700">{label}</text>
            </g>
          );
        })}

        {/* Annotations */}
        <rect x={14} y={H - 72} width={PW - 20} height={56} rx={3} fill="#FEF0F0" stroke="#c0392b" strokeWidth="1" />
        <text x={20} y={H - 58} fontSize="10" fill="#7B0D0D" fontWeight="700">Duffing oscillator: F(x) = kx + εαx³</text>
        <text x={20} y={H - 44} fontSize="9.5" fill="#333">εα {'>'} 0: hardening — frequency increases with amplitude</text>
        <text x={20} y={H - 30} fontSize="9.5" fill="#333">εα {'<'} 0: softening — frequency decreases with amplitude</text>
        <text x={20} y={H - 16} fontSize="9.5" fill="#555">Linear: εα = 0 — frequency independent of amplitude</text>

        {/* Panel 2: Potential energy wells */}
        <rect x={PW + 20} y={10} width={PW} height={H - 20} rx={5} fill="#fff" stroke="#f0cece" />
        <text x={PW + 20 + PW / 2} y={28} textAnchor="middle" fontSize="13" fill="#7B0D0D" fontWeight="700">Potential Energy Wells V(x) = −∫F dx</text>

        {/* Axes */}
        <line x1={ox2} y1={oy2 + 6} x2={ox2 + ow2 + 10} y2={oy2 + 6} stroke="#888" strokeWidth="1.5" markerEnd="url(#rf1)" />
        <line x1={ox2} y1={oy2 + 6} x2={ox2} y2={oy2 - oh2 - 10} stroke="#888" strokeWidth="1.5" markerEnd="url(#rf1)" />
        <text x={ox2 + ow2 + 14} y={oy2 + 10} fontSize="10" fill="#555">x</text>
        <text x={ox2 + 4} y={oy2 - oh2 - 12} fontSize="10" fill="#555">V</text>

        {[
          { ys: singleWell, col: '#c0392b', label: 'Single well (hardening)', ofs: 0.3 },
          { ys: doubleWell, col: '#2E75B6', label: 'Double well (bistable)', ofs: 1.2 },
          { ys: asymWell,   col: '#e07b00', label: 'Asymmetric well', ofs: -1.0 },
        ].map(({ ys, col, label, ofs }) => {
          const pts = xVals
            .filter((_, i) => {
              const v = ys[i];
              return v >= -0.05 && v <= 3.6;
            })
            .map((x, i) => {
              const fi = xVals.findIndex(xv => Math.abs(xv - x) < 0.001);
              return `${toX2(x)},${toY2(ys[fi])}`;
            }).join(' ');
          return (
            <g key={label}>
              <polyline points={pts} fill="none" stroke={col} strokeWidth="2.2" />
              <text x={toX2(ofs)} y={toY2(Math.max(ys[Math.round((ofs + 2.5) / 5 * (N - 1))], 0)) - 6}
                fontSize="9" fill={col} fontWeight="700">{label}</text>
            </g>
          );
        })}

        {/* Equilibrium points */}
        {[
          { x: 0, v: 0, col: '#c0392b', label: 'stable' },
          { x: 0, v: 0, col: '#2E75B6', label: 'unstable' },
          { x: 1.0, v: doubleWell[Math.round((1.0 + 2.5) / 5 * (N - 1))], col: '#2E75B6', label: 'stable' },
          { x: -1.0, v: doubleWell[Math.round((-1.0 + 2.5) / 5 * (N - 1))], col: '#2E75B6', label: 'stable' },
        ].map(({ x, v, col, label }, i) => (
          <g key={i}>
            <circle cx={toX2(x)} cy={toY2(Math.max(v, 0))} r={4}
              fill={label === 'stable' ? col : '#fff'} stroke={col} strokeWidth="2" />
          </g>
        ))}

        {/* Double well annotation */}
        <rect x={PW + 26} y={H - 72} width={PW - 14} height={56} rx={3} fill="#eaf3ff" stroke="#2E75B6" strokeWidth="1" />
        <text x={PW + 32} y={H - 58} fontSize="10" fill="#2E75B6" fontWeight="700">Double well: V = −x²/2 + x⁴/4</text>
        <text x={PW + 32} y={H - 44} fontSize="9.5" fill="#333">Two stable equilibria (x = ±1) and one unstable (x = 0)</text>
        <text x={PW + 32} y={H - 30} fontSize="9.5" fill="#333">Energy above barrier: chaotic or cross-well oscillation</text>
        <text x={PW + 32} y={H - 16} fontSize="9.5" fill="#555">Below barrier: small oscillations near one well (linear-like)</text>
      </svg>
      <div style={S.dCaption}>The restoring force characteristic fundamentally determines system behaviour. A linear spring produces frequency-independent oscillations; a hardening spring (Duffing+) causes the resonance frequency to increase with amplitude, bending the frequency-response curve to the right; a softening spring bends it left. Bilinear stiffness and dead-band (backlash/clearance) are common in mechanical joints, gear teeth, and preloaded contacts. The potential energy well picture reveals equilibrium stability: a local minimum is a stable equilibrium, a local maximum is unstable, and a double-well potential supports two coexisting oscillation states.</div>
    </div>
  );
}

// ── Diagram 2: Duffing Oscillator — Backbone and Jump Phenomenon ──
function DiagramDuffing() {
  const W = 900, H = 370;
  const PW = (W - 30) / 2;

  // Frequency response curve for Duffing equation (hardening)
  // Using the amplitude-frequency relationship from perturbation theory:
  // (ω² - ωₙ² - 3εα a²/4)² + (ζωωₙ)² a² = (F₀/m)² (simplified)
  // Sweep ω from low to high AND high to low to capture jump

  const wn = 1.0, eps = 0.4, zeta = 0.1, F0 = 0.3, m = 1.0;

  const buildCurve = (wStart, wEnd, nPts, aInit) => {
    const ws = Array.from({ length: nPts }, (_, i) => wStart + i / (nPts - 1) * (wEnd - wStart));
    const pts = [];
    let a = aInit;
    for (const w of ws) {
      // Newton iteration on: R(a) = [(w²-wn²-3eps*a²/4)²a² + (2*zeta*wn*w*a)²] - F0² = 0
      for (let iter = 0; iter < 40; iter++) {
        const detuning = w * w - wn * wn - 0.75 * eps * a * a;
        const damp = 2 * zeta * wn * w;
        const R = detuning * detuning * a * a + damp * damp * a * a - F0 * F0;
        const dR = (2 * detuning * (-1.5 * eps * a) * a * a + detuning * detuning * 2 * a
          + damp * damp * 2 * a);
        if (Math.abs(dR) < 1e-12) break;
        const da = -R / dR;
        a = Math.max(0.001, a + da * 0.5);
        if (Math.abs(da) < 1e-8) break;
      }
      if (a > 0.01 && a < 8) pts.push({ w, a });
    }
    return pts;
  };

  const upSweep = buildCurve(0.3, 2.2, 400, 0.1);
  const downSweep = buildCurve(2.2, 0.3, 400, 0.5);

  // Backbone curve: ω_peak = ωₙ√(1 + 3εa²/4ωₙ²)
  const backboneA = Array.from({ length: 60 }, (_, i) => i / 59 * 3.5);
  const backboneW = backboneA.map(a => wn * Math.sqrt(1 + 0.75 * eps * a * a / (wn * wn)));

  const ox = 14, oy2 = 40, ow = PW - 28, plotH = 250;
  const wMax = 2.2, aMax = 3.2;
  const toX = w => ox + (w - 0.3) / (wMax - 0.3) * ow;
  const toY = a => oy2 + plotH - Math.min(a / aMax, 1) * plotH;

  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Duffing Oscillator — Frequency Response, Backbone Curve, and Jump Phenomenon</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{ width: '100%', display: 'block' }}>
        <defs>
          <marker id="df1" markerWidth="6" markerHeight="6" refX="5" refY="3" orient="auto">
            <polygon points="0 0,6 3,0 6" fill="#888" />
          </marker>
          <marker id="df2" markerWidth="7" markerHeight="7" refX="5" refY="3.5" orient="auto">
            <polygon points="0 0,6 3.5,0 7" fill="#c0392b" />
          </marker>
          <marker id="df3" markerWidth="7" markerHeight="7" refX="5" refY="3.5" orient="auto">
            <polygon points="0 0,6 3.5,0 7" fill="#2E75B6" />
          </marker>
        </defs>

        {/* Panel 1: Frequency response with jump */}
        <rect x={10} y={10} width={PW} height={H - 20} rx={5} fill="#fff" stroke="#f0cece" />
        <text x={10 + PW / 2} y={28} textAnchor="middle" fontSize="13" fill="#7B0D0D" fontWeight="700">Hardening Duffing: Amplitude vs. Frequency (Jump Phenomenon)</text>

        {/* Grid */}
        {[0, 0.5, 1.0, 1.5, 2.0, 2.5, 3.0].map(a => {
          const y = toY(a);
          return (
            <g key={a}>
              <line x1={ox} y1={y} x2={ox + ow} y2={y} stroke="#f5f5f5" strokeWidth="1" />
              <text x={ox - 4} y={y + 4} textAnchor="end" fontSize="9" fill="#aaa">{a}</text>
            </g>
          );
        })}
        {[0.5, 1.0, 1.5, 2.0].map(w => {
          const x = toX(w);
          return (
            <g key={w}>
              <line x1={x} y1={oy2} x2={x} y2={oy2 + plotH} stroke="#f0f0f0" strokeWidth={w === 1.0 ? 1.5 : 1} />
              <text x={x} y={oy2 + plotH + 14} textAnchor="middle" fontSize="9" fill="#aaa">{w}</text>
            </g>
          );
        })}

        {/* Linear response (ε=0) */}
        {(() => {
          const pts = Array.from({ length: 300 }, (_, i) => {
            const w = 0.3 + i / 299 * (wMax - 0.3);
            const a = F0 / Math.sqrt((wn * wn - w * w) ** 2 + (2 * zeta * wn * w) ** 2);
            if (a > aMax) return null;
            return `${toX(w)},${toY(a)}`;
          }).filter(Boolean).join(' ');
          return <polyline points={pts} fill="none" stroke="#bbb" strokeWidth="1.5" strokeDasharray="6,3" />;
        })()}

        {/* Up-sweep (jump up) */}
        <polyline
          points={upSweep.map(({ w, a }) => `${toX(w)},${toY(a)}`).join(' ')}
          fill="none" stroke="#c0392b" strokeWidth="2.5"
        />

        {/* Down-sweep (jump down) */}
        <polyline
          points={downSweep.map(({ w, a }) => `${toX(w)},${toY(a)}`).join(' ')}
          fill="none" stroke="#2E75B6" strokeWidth="2" strokeDasharray="5,3"
        />

        {/* Backbone curve */}
        <polyline
          points={backboneA.map((a, i) => `${toX(backboneW[i])},${toY(a)}`).join(' ')}
          fill="none" stroke="#27ae60" strokeWidth="2" strokeDasharray="3,2"
        />
        <text x={toX(backboneW[40]) + 4} y={toY(backboneA[40])} fontSize="9.5" fill="#27ae60" fontWeight="700">Backbone</text>
        <text x={toX(backboneW[40]) + 4} y={toY(backboneA[40]) + 12} fontSize="9" fill="#27ae60">curve</text>

        {/* Jump annotations */}
        {(() => {
          const jumpUpIdx = upSweep.findIndex((p, i) => i > 0 && upSweep[i - 1].a < p.a * 0.7 && p.w > 1.1);
          if (jumpUpIdx > 10) {
            const p = upSweep[jumpUpIdx];
            return (
              <g>
                <line x1={toX(p.w) - 2} y1={toY(p.a) + 20} x2={toX(p.w) - 2} y2={toY(p.a) + 2}
                  stroke="#c0392b" strokeWidth="2" markerEnd="url(#df2)" />
                <text x={toX(p.w) - 30} y={toY(p.a) + 34} fontSize="9.5" fill="#c0392b" fontWeight="700">Jump UP</text>
              </g>
            );
          }
          return null;
        })()}

        {/* Axes */}
        <line x1={ox} y1={oy2} x2={ox} y2={oy2 + plotH + 4} stroke="#888" strokeWidth="1.5" />
        <line x1={ox} y1={oy2 + plotH} x2={ox + ow + 8} y2={oy2 + plotH} stroke="#888" strokeWidth="1.5" markerEnd="url(#df1)" />
        <text x={ox + ow / 2} y={oy2 + plotH + 26} textAnchor="middle" fontSize="10" fill="#555">Excitation Frequency ω</text>
        <text x={ox - 18} y={oy2 + plotH / 2} fontSize="9.5" fill="#555" transform={`rotate(-90,${ox - 18},${oy2 + plotH / 2})`} textAnchor="middle">Amplitude a</text>

        {/* Unstable branch shading */}
        <rect x={toX(1.02)} y={oy2 + 20} width={toX(1.55) - toX(1.02)} height={plotH - 20}
          fill="#fff0f0" opacity="0.4" />
        <text x={(toX(1.02) + toX(1.55)) / 2} y={oy2 + 36} textAnchor="middle" fontSize="9" fill="#c0392b" opacity="0.7">Unstable</text>
        <text x={(toX(1.02) + toX(1.55)) / 2} y={oy2 + 48} textAnchor="middle" fontSize="9" fill="#c0392b" opacity="0.7">branch</text>

        {/* Legend */}
        <line x1={ox + 8} y1={H - 80} x2={ox + 28} y2={H - 80} stroke="#bbb" strokeWidth="1.5" strokeDasharray="5,3" />
        <text x={ox + 32} y={H - 76} fontSize="9.5" fill="#777">Linear (ε=0)</text>
        <line x1={ox + 8} y1={H - 64} x2={ox + 28} y2={H - 64} stroke="#c0392b" strokeWidth="2.5" />
        <text x={ox + 32} y={H - 60} fontSize="9.5" fill="#c0392b">Up-sweep (jump up at ω↑)</text>
        <line x1={ox + 8} y1={H - 48} x2={ox + 28} y2={H - 48} stroke="#2E75B6" strokeWidth="2" strokeDasharray="5,2" />
        <text x={ox + 32} y={H - 44} fontSize="9.5" fill="#2E75B6">Down-sweep (jump down at ω↓)</text>
        <line x1={ox + 8} y1={H - 32} x2={ox + 28} y2={H - 32} stroke="#27ae60" strokeWidth="2" strokeDasharray="3,2" />
        <text x={ox + 32} y={H - 28} fontSize="9.5" fill="#27ae60">Backbone curve (free vibration locus)</text>

        {/* Panel 2: Phase portrait + time response comparison */}
        <rect x={PW + 20} y={10} width={PW} height={H - 20} rx={5} fill="#fff" stroke="#f0cece" />
        <text x={PW + 20 + PW / 2} y={28} textAnchor="middle" fontSize="13" fill="#7B0D0D" fontWeight="700">Jump Phenomenon Summary and Key Features</text>

        {[
          { y: 38, col: '#c0392b', bg: '#FEF0F0', bc: '#c0392b',
            title: 'Hardening spring (εα > 0)',
            lines: ['Resonance peak leans RIGHT (to higher ω)', 'Jump UP occurs at higher ω during up-sweep', 'Jump DOWN occurs at lower ω during down-sweep', 'Hysteresis band between jump frequencies'] },
          { y: 124, col: '#2E75B6', bg: '#eaf3ff', bc: '#2E75B6',
            title: 'Softening spring (εα < 0)',
            lines: ['Resonance peak leans LEFT (to lower ω)', 'Jump DOWN at lower ω during down-sweep', 'Jump UP at higher ω during up-sweep', 'Hysteresis band reversed from hardening'] },
          { y: 210, col: '#27ae60', bg: '#f0fff4', bc: '#27ae60',
            title: 'Backbone curve',
            lines: ['Locus of amplitude vs. natural frequency', 'For Duffing: ω_backbone = ωₙ√(1 + 3εα a²/4ωₙ²)', 'Tangent to all amplitude-frequency curves', 'Identifies nonlinearity type and strength'] },
          { y: 290, col: '#e07b00', bg: '#fff9e6', bc: '#e07b00',
            title: 'Multi-valued response region',
            lines: ['Three solutions exist between jump freqs', 'Upper and lower branches: stable', 'Middle branch: UNSTABLE (not observable)', 'Fold (saddle-node) bifurcations at jumps'] },
        ].map(({ y, col, bg, bc, title, lines }) => (
          <g key={y}>
            <rect x={PW + 26} y={y} width={PW - 14} height={lines.length * 17 + 20} rx={3} fill={bg} stroke={bc} strokeWidth="1.2" />
            <text x={PW + 32} y={y + 15} fontSize="11" fill={col} fontWeight="700">{title}</text>
            {lines.map((line, li) => (
              <text key={li} x={PW + 32} y={y + 30 + li * 17} fontSize="9.5" fill="#333">{line}</text>
            ))}
          </g>
        ))}
      </svg>
      <div style={S.dCaption}>The Duffing oscillator (x'' + 2ζωₙx' + ωₙ²x + εαx³ = F cos ωt) exhibits frequency-amplitude dependence absent in linear systems. The frequency-response curve bends toward higher frequencies for hardening nonlinearity, creating a multi-valued region where two stable amplitudes coexist at the same frequency. As frequency is swept upward, the amplitude follows the upper branch until it jumps discontinuously down; sweeping downward, it follows the lower branch then jumps up. This hysteresis is a hallmark of nonlinear resonance and cannot occur in any linear system.</div>
    </div>
  );
}

// ── Diagram 3: Phase Plane and Limit Cycles ───────────────────────
function DiagramPhasePlane() {
  const W = 900, H = 330;
  const PW = (W - 30) / 2;

  // Van der Pol limit cycle: x'' - μ(1-x²)x' + x = 0
  // Numerical integration via Euler
  const integrateVdP = (mu, x0, v0, dt, nSteps) => {
    const pts = [];
    let x = x0, v = v0;
    for (let i = 0; i < nSteps; i++) {
      const ax = mu * (1 - x * x) * v - x;
      v += ax * dt;
      x += v * dt;
      if (i % 3 === 0 && Math.abs(x) < 4 && Math.abs(v) < 4) pts.push([x, v]);
    }
    return pts;
  };

  const mu = 1.2;
  const lcPts    = integrateVdP(mu, 0.1, 0.0, 0.02, 3000).slice(-300);
  const outerPts = integrateVdP(mu, 3.5, 0.0, 0.02, 2000).slice(-300);
  const spiralPts = integrateVdP(0.5, 0.2, 0.0, 0.02, 1500);

  const cx1 = 10 + PW / 2, cy1 = 165, sc = 52;
  const toXp = (x, cx) => cx + x * sc;
  const toYp = (v, cy) => cy - v * sc;

  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Phase Plane Analysis — Limit Cycles, Attractors, and Van der Pol Oscillator</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{ width: '100%', display: 'block' }}>
        <defs>
          <marker id="pp1" markerWidth="6" markerHeight="6" refX="5" refY="3" orient="auto">
            <polygon points="0 0,6 3,0 6" fill="#888" />
          </marker>
        </defs>

        {/* Panel 1: Van der Pol phase plane */}
        <rect x={10} y={10} width={PW} height={H - 20} rx={5} fill="#fff" stroke="#f0cece" />
        <text x={cx1} y={28} textAnchor="middle" fontSize="13" fill="#7B0D0D" fontWeight="700">Van der Pol — Stable Limit Cycle (μ=1.2)</text>

        {/* Axes */}
        <line x1={10 + 14} y1={cy1} x2={10 + PW - 10} y2={cy1} stroke="#ddd" strokeWidth="1.5" markerEnd="url(#pp1)" />
        <line x1={cx1} y1={H - 24} x2={cx1} y2={16} stroke="#ddd" strokeWidth="1.5" markerEnd="url(#pp1)" />
        <text x={10 + PW - 12} y={cy1 + 14} fontSize="10" fill="#aaa">x</text>
        <text x={cx1 + 4} y={20} fontSize="10" fill="#aaa">x'</text>

        {/* Grid circles */}
        {[52, 104, 156].map(r => (
          <circle key={r} cx={cx1} cy={cy1} r={r} fill="none" stroke="#f5f5f5" strokeWidth="1" />
        ))}

        {/* Outer trajectory spiraling inward */}
        <polyline
          points={outerPts.map(([x, v]) => `${toXp(x, cx1)},${toYp(v, cy1)}`).join(' ')}
          fill="none" stroke="#2E75B6" strokeWidth="1.5" opacity="0.7"
        />

        {/* Inner trajectory spiraling outward */}
        <polyline
          points={spiralPts.map(([x, v]) => `${toXp(x, cx1)},${toYp(v, cy1)}`).join(' ')}
          fill="none" stroke="#e07b00" strokeWidth="1.5" opacity="0.8"
        />

        {/* Limit cycle (steady state) */}
        <polyline
          points={lcPts.map(([x, v]) => `${toXp(x, cx1)},${toYp(v, cy1)}`).join(' ')}
          fill="none" stroke="#c0392b" strokeWidth="2.5"
        />

        {/* Labels */}
        <text x={cx1 + 70} y={cy1 - 90} fontSize="9.5" fill="#c0392b" fontWeight="700">Limit cycle</text>
        <text x={cx1 + 70} y={cy1 - 78} fontSize="9" fill="#c0392b">(stable attractor)</text>
        <text x={cx1 - 120} y={cy1 + 115} fontSize="9.5" fill="#2E75B6">Outer trajectory</text>
        <text x={cx1 - 120} y={cy1 + 127} fontSize="9" fill="#2E75B6">(spirals inward)</text>
        <text x={cx1 + 24} y={cy1 + 34} fontSize="9.5" fill="#e07b00">Inner spiral</text>
        <text x={cx1 + 24} y={cy1 + 46} fontSize="9" fill="#e07b00">(grows outward)</text>

        {/* VdP equation */}
        <rect x={14} y={H - 56} width={PW - 20} height={42} rx={3} fill="#FEF0F0" stroke="#c0392b" strokeWidth="1.5" />
        <text x={20} y={H - 42} fontSize="10" fill="#7B0D0D" fontWeight="700">Van der Pol: x'' − μ(1−x²)x' + x = 0</text>
        <text x={20} y={H - 28} fontSize="9.5" fill="#333">μ {'>'} 0: negative damping for |x| {'<'} 1, positive for |x| {'>'} 1</text>
        <text x={20} y={H - 14} fontSize="9.5" fill="#555">All trajectories converge to unique limit cycle regardless of IC</text>

        {/* Panel 2: Phase plane topology reference */}
        <rect x={PW + 20} y={10} width={PW} height={H - 20} rx={5} fill="#fff" stroke="#f0cece" />
        <text x={PW + 20 + PW / 2} y={28} textAnchor="middle" fontSize="13" fill="#7B0D0D" fontWeight="700">Phase Plane Equilibrium Types</text>

        {[
          { cx: PW + 90,  cy: 105, type: 'Stable Node',    col: '#27ae60',
            arcs: [[-30,-30],[30,-20],[-20,30],[28,28],[-28,15],[15,-28]] },
          { cx: PW + 240, cy: 105, type: 'Stable Spiral',  col: '#2E75B6',
            spiral: true, dir: 1 },
          { cx: PW + 390, cy: 105, type: 'Centre',         col: '#9b59b6',
            circles: true },
          { cx: PW + 90,  cy: 250, type: 'Unstable Node',  col: '#c0392b',
            arcs: [[-30,-30],[30,-20],[-20,30],[28,28],[-28,15],[15,-28]], out: true },
          { cx: PW + 240, cy: 250, type: 'Saddle Point',   col: '#e07b00',
            saddle: true },
          { cx: PW + 390, cy: 250, type: 'Limit Cycle',    col: '#c0392b',
            limitCycle: true },
        ].map(({ cx, cy, type, col, arcs, out, spiral, dir, circles, saddle, limitCycle }) => {
          const r = 40;
          return (
            <g key={type}>
              <circle cx={cx} cy={cy} r={6} fill={col} opacity="0.2" stroke={col} strokeWidth="1" />
              <circle cx={cx} cy={cy} r={3} fill={col} />
              <text x={cx} y={cy + r + 14} textAnchor="middle" fontSize="9.5" fill={col} fontWeight="700">{type}</text>

              {circles && [24, 36].map(rr => (
                <circle key={rr} cx={cx} cy={cy} r={rr} fill="none" stroke={col} strokeWidth="1.5" />
              ))}

              {limitCycle && (
                <>
                  <circle cx={cx} cy={cy} r={32} fill="none" stroke={col} strokeWidth="2.5" />
                  <circle cx={cx} cy={cy} r={16} fill="none" stroke={col} strokeWidth="1.2" strokeDasharray="3,2" opacity="0.5" />
                  <circle cx={cx} cy={cy} r={44} fill="none" stroke={col} strokeWidth="1.2" strokeDasharray="3,2" opacity="0.5" />
                </>
              )}

              {saddle && (
                <>
                  {/* Stable manifold (inward along y-axis) */}
                  <line x1={cx} y1={cy - r} x2={cx} y2={cy - 6} stroke={col} strokeWidth="1.5" markerEnd="url(#pp1)" />
                  <line x1={cx} y1={cy + r} x2={cx} y2={cy + 6} stroke={col} strokeWidth="1.5" markerEnd="url(#pp1)" />
                  {/* Unstable manifold (outward along x-axis) */}
                  <line x1={cx - 6} y1={cy} x2={cx - r} y2={cy} stroke={col} strokeWidth="1.5" markerEnd="url(#pp1)" />
                  <line x1={cx + 6} y1={cy} x2={cx + r} y2={cy} stroke={col} strokeWidth="1.5" markerEnd="url(#pp1)" />
                  {/* Hyperbolic trajectories */}
                  <path d={`M${cx - r},${cy - r * 0.5} Q${cx - 10},${cy - 8} ${cx - r},${cy + r * 0.5}`} fill="none" stroke={col} strokeWidth="1.2" />
                  <path d={`M${cx + r},${cy - r * 0.5} Q${cx + 10},${cy - 8} ${cx + r},${cy + r * 0.5}`} fill="none" stroke={col} strokeWidth="1.2" />
                </>
              )}

              {spiral && (
                <path d={`M${cx + r},${cy} A${r},${r * 0.8} 0 1 ${dir === 1 ? 0 : 1} ${cx},${cy - r * 0.6} A${r * 0.6},${r * 0.5} 0 1 ${dir === 1 ? 0 : 1} ${cx + r * 0.3},${cy + r * 0.3}`}
                  fill="none" stroke={col} strokeWidth="1.5" markerEnd="url(#pp1)" />
              )}

              {arcs && arcs.map(([dx, dy], ai) => (
                <line key={ai} x1={cx + dx} y1={cy + dy}
                  x2={cx + dx * (out ? 0.3 : 0.1)}
                  y2={cy + dy * (out ? 0.3 : 0.1)}
                  stroke={col} strokeWidth="1.2" markerEnd="url(#pp1)" />
              ))}
            </g>
          );
        })}
      </svg>
      <div style={S.dCaption}>The phase plane (x vs. x') reveals the global dynamics of a system. Each initial condition traces a unique trajectory; the long-time behaviour converges to an attractor. A stable equilibrium is approached by spiraling or nodal trajectories; a saddle point has a stable manifold (attraction) and an unstable manifold (repulsion). A limit cycle is a periodic attractor — self-sustained oscillation with constant amplitude regardless of initial conditions. The Van der Pol oscillator is the classic model of self-sustained oscillation, with energy-dependent damping that pumps energy in at small amplitudes and dissipates it at large amplitudes.</div>
    </div>
  );
}

// ── Diagram 4: Superharmonic, Subharmonic, Quasi-periodic ────────
function DiagramFrequencyContent() {
  const W = 900, H = 330;
  const PW = (W - 30) / 2;

  // Simulate a nonlinear system response with harmonics
  const N = 512;
  const dt = 0.02, omega = 2.1, wn = 1.0, eps = 0.4, zeta = 0.08, F0 = 0.5;
  const t = Array.from({ length: N }, (_, i) => i * dt);

  // Approximate response including superharmonics
  const xResp = t.map(tv =>
    0.6 * Math.cos(omega * tv - 0.3)
    + 0.12 * Math.cos(3 * omega * tv - 1.1)    // 3rd superharmonic
    + 0.04 * Math.cos(5 * omega * tv - 0.8)    // 5th superharmonic
    + 0.08 * Math.cos(omega / 3 * tv + 0.2)    // subharmonic 1/3
  );

  // FFT-like magnitude spectrum (discrete frequencies)
  const freqLines = [
    { f: omega / 3, A: 0.08, col: '#9b59b6', label: 'ω/3 (subharmonic)' },
    { f: omega,     A: 0.60, col: '#c0392b', label: 'ω (fundamental)' },
    { f: 3 * omega, A: 0.12, col: '#e07b00', label: '3ω (superharmonic)' },
    { f: 5 * omega, A: 0.04, col: '#2E75B6', label: '5ω (superharmonic)' },
  ];

  const ox1 = 14, oy1 = 180, ow1 = PW - 28, oh1 = 130;
  const toXt = tv => ox1 + (tv / (N * dt)) * ow1;
  const toYt = v => oy1 - v * oh1 * 0.55;

  const ox2 = PW + 38, oy2 = 260, ow2 = PW - 48, oh2 = 190;
  const fMax = 16;
  const toXf = f => ox2 + (f / fMax) * ow2;
  const toYf = A => oy2 - Math.min(A / 0.65, 1) * oh2;

  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Nonlinear Frequency Content — Superharmonics, Subharmonics, and Quasi-periodic Response</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{ width: '100%', display: 'block' }}>
        <defs>
          <marker id="fc1" markerWidth="6" markerHeight="6" refX="5" refY="3" orient="auto">
            <polygon points="0 0,6 3,0 6" fill="#888" />
          </marker>
        </defs>

        {/* Panel 1: Time response */}
        <rect x={10} y={10} width={PW} height={H - 20} rx={5} fill="#fff" stroke="#f0cece" />
        <text x={10 + PW / 2} y={28} textAnchor="middle" fontSize="13" fill="#7B0D0D" fontWeight="700">Nonlinear Time Response (Duffing, ω=2.1)</text>
        <text x={10 + PW / 2} y={42} textAnchor="middle" fontSize="10" fill="#555">Response contains ω, 3ω, 5ω (superharmonics) and ω/3 (subharmonic)</text>

        {/* Axes */}
        <line x1={ox1} y1={oy1 + 4} x2={ox1 + ow1 + 10} y2={oy1 + 4} stroke="#888" strokeWidth="1.5" markerEnd="url(#fc1)" />
        <line x1={ox1} y1={oy1 + 4} x2={ox1} y2={oy1 - oh1 * 0.56 - 8} stroke="#888" strokeWidth="1.5" markerEnd="url(#fc1)" />
        <text x={ox1 + ow1 + 14} y={oy1 + 8} fontSize="10" fill="#555">t</text>
        <text x={ox1 + 4} y={oy1 - oh1 * 0.52} fontSize="10" fill="#555">x(t)</text>

        <line x1={ox1} y1={oy1} x2={ox1 + ow1} y2={oy1} stroke="#eee" strokeWidth="1" />

        <polyline
          points={t.map((tv, i) => `${toXt(tv)},${toYt(xResp[i])}`).join(' ')}
          fill="none" stroke="#c0392b" strokeWidth="2"
        />

        {/* Component overlays */}
        {[
          { comp: t.map(tv => 0.08 * Math.cos(omega / 3 * tv + 0.2)), col: '#9b59b6', dash: '4,2', label: 'ω/3' },
          { comp: t.map(tv => 0.12 * Math.cos(3 * omega * tv - 1.1)), col: '#e07b00', dash: '3,2', label: '3ω' },
        ].map(({ comp, col, dash, label }) => (
          <polyline key={label}
            points={t.map((tv, i) => `${toXt(tv)},${toYt(comp[i])}`).join(' ')}
            fill="none" stroke={col} strokeWidth="1.5" strokeDasharray={dash} opacity="0.7"
          />
        ))}

        {/* Frequency reference boxes */}
        {[
          { y: H - 72, col: '#9b59b6', bg: '#f8f0ff', bc: '#9b59b6', title: 'Subharmonic (1/3 order):', desc: 'Response at ω/3 when excited at ω\nOccurs at specific amplitude/detuning combinations\nRelated to period-3 orbit (Poincaré map)' },
          { y: H - 30, col: '#e07b00', bg: '#fff9e6', bc: '#e07b00', title: 'Superharmonic (3rd order):', desc: '3ω component generated by cubic nonlinearity' },
        ].slice(1).map(({ y, col, bg, bc, title, desc }) => (
          <rect key={y} x={14} y={y} width={PW - 20} height={20} rx={2} fill={bg} stroke={bc} strokeWidth="1">
            <title>{title}</title>
          </rect>
        ))}
        <rect x={14} y={H - 52} width={PW - 20} height={38} rx={3} fill="#fff9e6" stroke="#e07b00" strokeWidth="1" />
        <text x={20} y={H - 38} fontSize="10" fill="#7a4800" fontWeight="700">Superharmonics: generated by cubic nonlinearity x³</text>
        <text x={20} y={H - 24} fontSize="9.5" fill="#333">x³ = (A cos ωt)³ = (3A/4)cos ωt + (A/4)cos 3ωt + ...</text>
        <text x={20} y={H - 10} fontSize="9.5" fill="#555">Even nonlinearity (x²) generates 2ω, 4ω; odd (x³) → 3ω, 5ω</text>

        {/* Panel 2: Frequency spectrum */}
        <rect x={PW + 20} y={10} width={PW} height={H - 20} rx={5} fill="#fff" stroke="#f0cece" />
        <text x={PW + 20 + PW / 2} y={28} textAnchor="middle" fontSize="13" fill="#7B0D0D" fontWeight="700">Frequency Spectrum — Nonlinear Response</text>
        <text x={PW + 20 + PW / 2} y={42} textAnchor="middle" fontSize="10" fill="#555">Nonlinear systems: spectral lines at nω/m (rational multiples of excitation)</text>

        {/* Grid */}
        {[0, 0.2, 0.4, 0.6].map(A => {
          const y = toYf(A);
          return (
            <g key={A}>
              <line x1={ox2} y1={y} x2={ox2 + ow2} y2={y} stroke="#f5f5f5" strokeWidth="1" />
              <text x={ox2 - 4} y={y + 4} textAnchor="end" fontSize="9" fill="#aaa">{A}</text>
            </g>
          );
        })}

        {/* Spectral lines */}
        {freqLines.map(({ f, A, col, label }) => {
          const x = toXf(f);
          const y = toYf(A);
          return (
            <g key={f}>
              <line x1={x} y1={oy2} x2={x} y2={y + 2} stroke={col} strokeWidth="3" />
              <circle cx={x} cy={y} r={4} fill={col} />
              <text x={x} y={oy2 + 14} textAnchor="middle" fontSize="9" fill={col} fontWeight="700">{f.toFixed(1)}</text>
              <text x={x + 4} y={y - 6} fontSize="8.5" fill={col}>{label}</text>
            </g>
          );
        })}

        {/* Quasi-periodic sketch */}
        {(() => {
          const qpX = ox2 + ow2 * 0.55, qpY = 80, qpW = ow2 * 0.42, qpH = 100;
          return (
            <g>
              <rect x={qpX} y={qpY} width={qpW} height={qpH} rx={3} fill="#f8f0ff" stroke="#9b59b6" strokeWidth="1.5" />
              <text x={qpX + qpW / 2} y={qpY + 14} textAnchor="middle" fontSize="10.5" fill="#9b59b6" fontWeight="700">Quasi-periodic Response</text>
              {/* Beat-like pattern */}
              {Array.from({ length: 80 }, (_, i) => {
                const tv = i / 79 * qpW;
                const v = Math.cos(tv * 0.18) * Math.cos(tv * 0.022);
                return [qpX + tv, qpY + 55 - v * 30];
              }).map(([x, y], i, pts) => i === 0 ? null : (
                <line key={i}
                  x1={pts[i - 1][0]} y1={pts[i - 1][1]}
                  x2={x} y2={y}
                  stroke="#9b59b6" strokeWidth="1.5" opacity="0.8" />
              ))}
              <text x={qpX + 6} y={qpY + 82} fontSize="9" fill="#9b59b6">Two incommensurate freqs:</text>
              <text x={qpX + 6} y={qpY + 94} fontSize="9" fill="#9b59b6">ω₁/ω₂ irrational → never repeats</text>
            </g>
          );
        })()}

        {/* Axes */}
        <line x1={ox2} y1={oy2} x2={ox2 + ow2 + 8} y2={oy2} stroke="#888" strokeWidth="1.5" markerEnd="url(#fc1)" />
        <line x1={ox2} y1={oy2 - oh2 - 6} x2={ox2} y2={oy2 + 4} stroke="#888" strokeWidth="1.5" />
        <text x={ox2 + ow2 + 12} y={oy2 + 4} fontSize="10" fill="#555">f (Hz)</text>
        <text x={ox2 - 14} y={oy2 - oh2 / 2} fontSize="9.5" fill="#555" transform={`rotate(-90,${ox2 - 14},${oy2 - oh2 / 2})`} textAnchor="middle">|X(f)|</text>
      </svg>
      <div style={S.dCaption}>A key signature of nonlinearity is the generation of new frequencies not present in the excitation. A cubic nonlinearity (x³) produces superharmonics at 3ω, 5ω, ... when excited at ω, because expanding (cos ωt)³ yields cosine terms at ω and 3ω. Under certain conditions, subharmonics at ω/2, ω/3 can also emerge through period-doubling or period-tripling bifurcations. Quasi-periodic motion has two incommensurate frequencies whose ratio is irrational — the trajectory never exactly repeats but is bounded, tracing a torus attractor in phase space.</div>
    </div>
  );
}

// ── Diagram 5: Bifurcation Diagram and Period Doubling ────────────
function DiagramBifurcation() {
  const W = 900, H = 340;

  // Period-doubling route to chaos: logistic map as proxy for Poincare section
  // x_{n+1} = r * x_n * (1 - x_n)
  const nR = 500;
  const rVals = Array.from({ length: nR }, (_, i) => 2.5 + i / (nR - 1) * 1.5); // r from 2.5 to 4.0
  const bifPts = [];
  for (const r of rVals) {
    let x = 0.5;
    for (let i = 0; i < 300; i++) x = r * x * (1 - x);
    for (let i = 0; i < 100; i++) {
      x = r * x * (1 - x);
      bifPts.push({ r, x });
    }
  }

  const ox = 14, oy = 40, ow = 560, plotH = 250;
  const rMin = 2.5, rMax = 4.0, xMin = 0.0, xMax = 1.0;
  const toX = r => ox + (r - rMin) / (rMax - rMin) * ow;
  const toY = x => oy + plotH - (x - xMin) / (xMax - xMin) * plotH;

  // Period labels at key bifurcation points
  const bfPoints = [
    { r: 3.0,  label: 'P1→P2', y: 0.66 },
    { r: 3.449, label: 'P2→P4', y: 0.44 },
    { r: 3.544, label: 'P4→P8', y: 0.50 },
    { r: 3.57,  label: 'Chaos onset', y: 0.35 },
  ];

  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Bifurcation Diagram — Period-Doubling Route to Chaos (Logistic Map)</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{ width: '100%', display: 'block' }}>
        <defs>
          <marker id="bd1" markerWidth="6" markerHeight="6" refX="5" refY="3" orient="auto">
            <polygon points="0 0,6 3,0 6" fill="#888" />
          </marker>
        </defs>

        {/* Main bifurcation plot */}
        <rect x={10} y={10} width={600} height={H - 20} rx={5} fill="#fff" stroke="#f0cece" />
        <text x={10 + 300} y={28} textAnchor="middle" fontSize="13" fill="#7B0D0D" fontWeight="700">Bifurcation Diagram: x(n+1) = r·xₙ(1−xₙ)</text>
        <text x={10 + 300} y={42} textAnchor="middle" fontSize="10" fill="#555">Poincaré section values vs. control parameter r</text>

        {/* Grid */}
        {[0, 0.25, 0.5, 0.75, 1.0].map(xv => {
          const y = toY(xv);
          return (
            <g key={xv}>
              <line x1={ox} y1={y} x2={ox + ow} y2={y} stroke="#f5f5f5" strokeWidth="1" />
              <text x={ox - 4} y={y + 4} textAnchor="end" fontSize="9" fill="#aaa">{xv}</text>
            </g>
          );
        })}

        {/* Points */}
        {bifPts.map(({ r, x }, i) => {
          const px = toX(r), py = toY(x);
          if (px < ox || px > ox + ow || py < oy || py > oy + plotH) return null;
          // Color by period region
          const col = r < 3.0 ? '#27ae60' : r < 3.449 ? '#2E75B6' : r < 3.544 ? '#e07b00' : r < 3.57 ? '#c0392b' : '#7B0D0D';
          return <circle key={i} cx={px} cy={py} r={0.6} fill={col} opacity="0.6" />;
        })}

        {/* Bifurcation point markers */}
        {bfPoints.map(({ r, label, y }) => {
          const x = toX(r);
          const yp = toY(y);
          return (
            <g key={r}>
              <line x1={x} y1={oy} x2={x} y2={oy + plotH} stroke="#c0392b" strokeWidth="1" strokeDasharray="4,3" opacity="0.5" />
              <text x={x} y={oy + plotH + 14} textAnchor="middle" fontSize="8.5" fill="#c0392b" fontWeight="700" transform={`rotate(-45,${x},${oy + plotH + 14})`}>{label}</text>
            </g>
          );
        })}

        {/* Period labels */}
        {[
          { x: 2.75, text: 'Period 1', col: '#27ae60' },
          { x: 3.22, text: 'Period 2', col: '#2E75B6' },
          { x: 3.5,  text: 'P4', col: '#e07b00' },
          { x: 3.65, text: 'Chaos', col: '#7B0D0D' },
        ].map(({ x, text, col }) => (
          <text key={x} x={toX(x)} y={oy + 14} textAnchor="middle" fontSize="9.5" fill={col} fontWeight="700">{text}</text>
        ))}

        {/* Axes */}
        <line x1={ox} y1={oy} x2={ox} y2={oy + plotH + 4} stroke="#888" strokeWidth="1.5" />
        <line x1={ox} y1={oy + plotH} x2={ox + ow + 8} y2={oy + plotH} stroke="#888" strokeWidth="1.5" markerEnd="url(#bd1)" />
        <text x={ox + ow / 2} y={oy + plotH + 32} textAnchor="middle" fontSize="10" fill="#555">Control parameter r</text>
        <text x={ox - 18} y={oy + plotH / 2} fontSize="9.5" fill="#555" transform={`rotate(-90,${ox - 18},${oy + plotH / 2})`} textAnchor="middle">Attractor values</text>

        {/* r-axis labels */}
        {[2.5, 3.0, 3.5, 4.0].map(r => (
          <text key={r} x={toX(r)} y={oy + plotH + 14} textAnchor="middle" fontSize="9" fill="#aaa">{r}</text>
        ))}

        {/* Right panel: Feigenbaum and chaos theory */}
        <rect x={630} y={10} width={258} height={H - 20} rx={5} fill="#fff" stroke="#f0cece" />
        <text x={759} y={28} textAnchor="middle" fontSize="12" fill="#7B0D0D" fontWeight="700">Key Results</text>

        {[
          { y: 36, col: '#27ae60', bg: '#f0fff4', bc: '#27ae60',
            title: 'Feigenbaum constant δ',
            lines: ['δ = lim (rₙ−rₙ₋₁)/(rₙ₊₁−rₙ)', '≈ 4.6692 (universal)', 'Ratio of bifurcation spacings', 'Same for ALL systems with', 'period-doubling route!'] },
          { y: 136, col: '#c0392b', bg: '#FEF0F0', bc: '#c0392b',
            title: 'Onset of chaos',
            lines: ['At r_∞ ≈ 3.5699...', 'Infinite cascades of', 'period doublings converge', 'Lyapunov exponent → 0', 'then becomes positive'] },
          { y: 236, col: '#9b59b6', bg: '#f8f0ff', bc: '#9b59b6',
            title: 'Windows of order',
            lines: ['Periodic windows within', 'chaotic region (e.g. P3 at r≈3.83)', 'Sharkovskii theorem:', 'Period 3 → chaos (any n exists)'] },
        ].map(({ y, col, bg, bc, title, lines }) => (
          <g key={y}>
            <rect x={636} y={y} width={246} height={lines.length * 16 + 20} rx={3} fill={bg} stroke={bc} strokeWidth="1.2" />
            <text x={642} y={y + 14} fontSize="10.5" fill={col} fontWeight="700">{title}</text>
            {lines.map((line, li) => (
              <text key={li} x={642} y={y + 28 + li * 16} fontSize="9.5" fill="#333">{line}</text>
            ))}
          </g>
        ))}
      </svg>
      <div style={S.dCaption}>The bifurcation diagram reveals how a system's long-term behaviour changes with a control parameter. Starting with a stable fixed point (Period 1), successive doublings create Period 2, Period 4, Period 8,... attractors. The spacing between bifurcation points shrinks by the universal Feigenbaum constant δ ≈ 4.669. After an infinite cascade of doublings (at r_∞ ≈ 3.57), the attractor becomes chaotic — densely filling bands with sensitive dependence on initial conditions. Sharkovskii's theorem states that if a period-3 orbit exists, orbits of every period exist, making period-3 observation a sure sign of chaos.</div>
    </div>
  );
}

// ── Diagram 6: Poincaré Map and Strange Attractor ─────────────────
function DiagramPoincareAttractor() {
  const W = 900, H = 330;
  const PW = (W - 30) / 2;

  // Lorenz-like attractor projection (2D slice) using simplified Rössler
  const intRossler = (nSteps, dt, a, b, c) => {
    let x = 0.1, y = 0, z = 0;
    const pts = [];
    for (let i = 0; i < nSteps; i++) {
      const dx = -y - z;
      const dy = x + a * y;
      const dz = b + z * (x - c);
      x += dx * dt; y += dy * dt; z += dz * dt;
      if (i > 500 && i % 4 === 0 && Math.abs(x) < 25 && Math.abs(y) < 25) {
        pts.push([x, y]);
      }
    }
    return pts;
  };

  const attractor = intRossler(12000, 0.04, 0.2, 0.2, 5.7);

  const cx1 = 10 + PW / 2, cy1 = 165, scA = 9;
  const toXa = x => cx1 + x * scA;
  const toYa = y => cy1 - y * scA;

  // Poincaré section: vertical line x=0, y>0
  const poincare = attractor.filter(([x, y], i) =>
    i > 0 && attractor[i - 1][0] < 0 && x >= 0 && y > 0
  );

  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Poincaré Map and Strange Attractor — Rössler System</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{ width: '100%', display: 'block' }}>
        <defs>
          <marker id="pa1" markerWidth="6" markerHeight="6" refX="5" refY="3" orient="auto">
            <polygon points="0 0,6 3,0 6" fill="#888" />
          </marker>
        </defs>

        {/* Panel 1: Strange attractor */}
        <rect x={10} y={10} width={PW} height={H - 20} rx={5} fill="#fff" stroke="#f0cece" />
        <text x={cx1} y={28} textAnchor="middle" fontSize="13" fill="#7B0D0D" fontWeight="700">Rössler Strange Attractor (x-y projection)</text>

        {/* Axes */}
        <line x1={10 + 14} y1={cy1} x2={10 + PW - 10} y2={cy1} stroke="#eee" strokeWidth="1" />
        <line x1={cx1} y1={H - 24} x2={cx1} y2={14} stroke="#eee" strokeWidth="1" />
        <text x={10 + PW - 12} y={cy1 + 14} fontSize="10" fill="#ddd">x</text>
        <text x={cx1 + 4} y={20} fontSize="10" fill="#ddd">y</text>

        {/* Attractor plot */}
        {attractor.slice(0, -1).map(([x, y], i) => {
          const [nx, ny] = attractor[i + 1];
          const px1 = toXa(x), py1 = toYa(y);
          const px2 = toXa(nx), py2 = toYa(ny);
          if (Math.abs(px1 - cx1) > PW / 2 - 14 || Math.abs(py1 - cy1) > H / 2 - 14) return null;
          // Color by spiral arm
          const angle = Math.atan2(y, x);
          const hue = ((angle + Math.PI) / (2 * Math.PI) * 60 + 0);
          return (
            <line key={i} x1={px1} y1={py1} x2={px2} y2={py2}
              stroke={`hsl(${hue},70%,45%)`} strokeWidth="0.8" opacity="0.6" />
          );
        })}

        {/* Poincaré section line */}
        <line x1={cx1} y1={cy1 - 120} x2={cx1} y2={cy1 + 20}
          stroke="#c0392b" strokeWidth="1.5" strokeDasharray="4,2" opacity="0.8" />
        <text x={cx1 + 4} y={cy1 - 116} fontSize="9" fill="#c0392b">Poincaré</text>
        <text x={cx1 + 4} y={cy1 - 104} fontSize="9" fill="#c0392b">section</text>

        {/* Poincaré dots */}
        {poincare.slice(0, 50).map(([x, y], i) => {
          const px = toXa(x), py = toYa(y);
          if (Math.abs(px - cx1) > PW / 2 - 14 || py < 14 || py > H - 24) return null;
          return <circle key={i} cx={px} cy={py} r={3} fill="#c0392b" opacity="0.9" />;
        })}

        {/* Label */}
        <rect x={14} y={H - 52} width={PW - 20} height={38} rx={3} fill="#FEF0F0" stroke="#c0392b" strokeWidth="1" />
        <text x={20} y={H - 38} fontSize="10" fill="#7B0D0D" fontWeight="700">Rössler: x'=−y−z;  y'=x+ay;  z'=b+z(x−c)</text>
        <text x={20} y={H - 24} fontSize="9.5" fill="#333">a=0.2, b=0.2, c=5.7 → chaotic attractor</text>
        <text x={20} y={H - 10} fontSize="9.5" fill="#555">Fractal dimension ≈ 2.01; Lyapunov exponent λ₁ {'>'} 0</text>

        {/* Panel 2: Poincaré map and chaos properties */}
        <rect x={PW + 20} y={10} width={PW} height={H - 20} rx={5} fill="#fff" stroke="#f0cece" />
        <text x={PW + 20 + PW / 2} y={28} textAnchor="middle" fontSize="13" fill="#7B0D0D" fontWeight="700">Poincaré Map and Chaos Diagnostics</text>

        {[
          { y: 38, col: '#c0392b', bg: '#FEF0F0', bc: '#c0392b',
            title: 'Poincaré Map',
            lines: ['Stroboscopic sampling: record x,ẋ at each', 'period T of the forcing (or at fixed surface)', 'Periodic orbit → finite set of points', 'Quasi-periodic → closed curve', 'Chaotic → scattered fractal cloud'] },
          { y: 142, col: '#2E75B6', bg: '#eaf3ff', bc: '#2E75B6',
            title: 'Lyapunov Exponent λ',
            lines: ['Measures divergence rate of nearby trajectories', '|δx(t)| ≈ |δx₀| e^(λt)', 'λ > 0: chaotic (exponential divergence)', 'λ = 0: periodic/quasi-periodic', 'λ < 0: stable (converging)'] },
          { y: 248, col: '#9b59b6', bg: '#f8f0ff', bc: '#9b59b6',
            title: 'Fractal Dimension',
            lines: ['Strange attractors have non-integer dimension', 'Correlation dimension d_c from scaling of', 'point distances in phase space', 'Rössler: d_c ≈ 2.01  (slightly more than 2D)'] },
        ].map(({ y, col, bg, bc, title, lines }) => (
          <g key={y}>
            <rect x={PW + 26} y={y} width={PW - 14} height={lines.length * 17 + 20} rx={3} fill={bg} stroke={bc} strokeWidth="1.2" />
            <text x={PW + 32} y={y + 15} fontSize="11" fill={col} fontWeight="700">{title}</text>
            {lines.map((line, li) => (
              <text key={li} x={PW + 32} y={y + 30 + li * 17} fontSize="9.5" fill="#333">{line}</text>
            ))}
          </g>
        ))}
      </svg>
      <div style={S.dCaption}>The Poincaré map converts a continuous trajectory into a discrete map by recording the state at regular intervals (strobing). A periodic orbit produces a finite number of fixed points; a chaotic orbit produces a densely scattered cloud with fractal structure — the strange attractor. The Lyapunov exponent λ quantifies chaos: positive λ means exponential divergence of initially close trajectories (sensitive dependence on initial conditions). Strange attractors are geometric objects with fractal dimension — between 2 and 3 for the Rössler system — indicating the trajectory fills space in a manner intermediate between a surface and a volume.</div>
    </div>
  );
}

// ── Diagram 7: Perturbation Methods — Lindstedt-Poincaré ─────────
function DiagramPerturbation() {
  const W = 900, H = 310;

  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Analytical Methods — Perturbation Theory and Harmonic Balance</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{ width: '100%', display: 'block' }}>
        <defs>
          <marker id="pm1" markerWidth="7" markerHeight="7" refX="5" refY="3.5" orient="auto">
            <polygon points="0 0,6 3.5,0 7" fill="#c0392b" />
          </marker>
        </defs>

        {/* Method cards */}
        {[
          {
            x: 10, title: 'Lindstedt-Poincaré Method',
            col: '#c0392b', bg: '#FEF0F0', bc: '#c0392b',
            lines: [
              'x = x₀ + εx₁ + ε²x₂ + ...',
              'ω = ω₀ + εω₁ + ε²ω₂ + ...',
              'Expand both solution AND frequency',
              'Eliminates secular terms by choosing ωₙ',
              '',
              'For Duffing x\'\' + x + εx³ = 0:',
              '  ω² = 1 + (3ε/4)a²  (hardening)',
              '  x ≈ a cos(ωt) − (εa³/32)cos(3ωt)',
              '',
              'Accuracy: O(ε²) for small ε',
              'Fails near resonance or for large ε',
            ],
          },
          {
            x: 226, title: 'Method of Multiple Scales (MMS)',
            col: '#2E75B6', bg: '#eaf3ff', bc: '#2E75B6',
            lines: [
              'Introduce slow T₁=εt and fast T₀=t timescales',
              'x = x₀(T₀,T₁) + εx₁(T₀,T₁) + ...',
              'Solvability condition eliminates secular terms',
              '',
              'Yields amplitude-phase modulation equations:',
              '  da/dT₁ = −ζa + (F₀/2ωₙ)sin φ',
              '  a dφ/dT₁ = σa − (3ε/8ωₙ)a³ + (F₀/2ωₙ)cos φ',
              '',
              'σ = detuning parameter (ω − ωₙ)/ε',
              'Steady state: da/dt=0, dφ/dt=0 → frequency response',
            ],
          },
          {
            x: 452, title: 'Harmonic Balance (HB)',
            col: '#27ae60', bg: '#f0fff4', bc: '#27ae60',
            lines: [
              'Assume: x(t) = a₁cos ωt + b₁sin ωt',
              '              + a₃cos 3ωt + b₃sin 3ωt + ...',
              'Substitute into EOM and balance coefficients',
              'of each harmonic separately',
              '',
              'For Duffing (1st harmonic):',
              '  (ωₙ²−ω²)a₁ + (3ε/4)(a₁²+b₁²)a₁ = F₀',
              '  −2ζω a₁ + ... = 0',
              '',
              'Exact for integer harmonics; powerful for',
              'strong nonlinearity; can miss sub-harmonics',
            ],
          },
          {
            x: 678, title: 'Averaging Method (Krylov-B-M)',
            col: '#e07b00', bg: '#fff9e6', bc: '#e07b00',
            lines: [
              'Write x = a(t)cos(ωt+φ(t))',
              'Slowly varying a(t), φ(t)',
              '',
              'Averaged equations (over one period):',
              "  a' = −(1/2π)∫ f(x,x')sin θ dθ",
              "  aφ' = −(1/2π)∫ f(x,x')cos θ dθ",
              '',
              'Gives slow envelope dynamics',
              'Works for any small nonlinearity f(x,ẋ)',
              'Van der Pol: a→ 2 exponentially',
            ],
          },
        ].map(({ x, title, col, bg, bc, lines }) => (
          <g key={x}>
            <rect x={x} y={10} width={208} height={H - 20} rx={5} fill={bg} stroke={bc} strokeWidth="1.8" />
            <rect x={x} y={10} width={208} height={26} rx={4} fill={bc} />
            <text x={x + 104} y={26} textAnchor="middle" fontSize="10.5" fill="#fff" fontWeight="700">{title}</text>
            {lines.map((line, li) => (
              <text key={li} x={x + 8} y={48 + li * 18} fontSize="9.5" fill={line === '' ? '#fff' : '#333'}
                fontFamily={line.includes('=') || line.includes('+') || line.includes('→') ? "'Courier New',monospace" : 'inherit'}>
                {line}
              </text>
            ))}
          </g>
        ))}
      </svg>
      <div style={S.dCaption}>Analytical methods for nonlinear vibrations seek approximate solutions valid for small nonlinearity (ε ≪ 1). The Lindstedt-Poincaré method corrects both the solution and the frequency simultaneously, avoiding the secular (unbounded) terms that plague naive perturbation expansions. The method of multiple scales separates fast oscillation from slow amplitude and phase evolution, yielding coupled modulation equations whose steady states give the full nonlinear frequency-response curve. Harmonic balance directly matches harmonic components and can handle strong nonlinearity. All three methods agree to O(ε) and predict the same backbone curve.</div>
    </div>
  );
}

// ── Diagram 8: Practical Nonlinear Systems ────────────────────────
function DiagramPracticalSystems() {
  const W = 900, H = 270;
  const systems = [
    {
      title: 'Large-Amplitude\nPendulum',
      col: '#c0392b', bg: '#FEF0F0', bc: '#c0392b',
      icon: '⊙',
      lines: [
        'θ\'\' + (g/L)sin θ = 0',
        'Exact period: T = 4√(L/g)K(sin(θ₀/2))',
        'K = complete elliptic integral',
        'For θ₀ = 90°: T is 18% longer than 2π√(L/g)',
        'Isochronous only for small θ₀',
      ],
    },
    {
      title: 'Gear Backlash\n/ Impact',
      col: '#2E75B6', bg: '#eaf3ff', bc: '#2E75B6',
      icon: '⚙',
      lines: [
        'Bilinear stiffness: k=0 in clearance zone',
        'Impact at gear tooth contact',
        'Coefficient of restitution r = v_after/v_before',
        'Energy loss per impact: ΔE = ½m v²(1−r²)',
        'Rattling: chaotic impacts at low torque',
      ],
    },
    {
      title: 'Structural\nDamping (Hysteresis)',
      col: '#27ae60', bg: '#f0fff4', bc: '#27ae60',
      icon: '⟳',
      lines: [
        'Force-displacement hysteresis loop',
        'Energy dissipated per cycle = loop area',
        'Bouc-Wen model: F = αkx + (1−α)k z',
        'z evolves via: ż = Aẋ − β|ẋ|z|z|ⁿ⁻¹ − γẋ|z|ⁿ',
        'Captures stiffness degradation + pinching',
      ],
    },
    {
      title: 'Dry Friction\n(Coulomb)',
      col: '#e07b00', bg: '#fff9e6', bc: '#e07b00',
      icon: '≡',
      lines: [
        'F_friction = μN·sign(ẋ)  (velocity-dependent sign)',
        'Stick-slip: static friction > kinetic friction',
        'Equivalent viscous damping: c_eq = 4μN/(πaω)',
        'Amplitude-dependent: more friction → lower amplitude',
        'Can cause self-excited vibration (squealing)',
      ],
    },
    {
      title: 'Fluid-Elastic\nInstability',
      col: '#9b59b6', bg: '#f8f0ff', bc: '#9b59b6',
      icon: '≈',
      lines: [
        'Negative aerodynamic damping: c_aero < 0',
        'Total damping: c_total = c_struct + c_aero',
        'Flutter onset: c_total = 0 (Hopf bifurcation)',
        'Limit cycle flutter: bounded by nonlinearity',
        'Examples: bridge galloping, wing flutter, NVH',
      ],
    },
    {
      title: 'Nonlinear Energy\nSink (NES)',
      col: '#7B0D0D', bg: '#fff5f5', bc: '#c0392b',
      icon: '◈',
      lines: [
        'Purely nonlinear coupling: k_NES = εx³ (no k_linear)',
        'No preferred frequency — broadband absorption',
        'Targeted energy transfer (TET) to NES',
        'Works across all frequencies unlike DVA',
        'Applications: aerospace, civil structures',
      ],
    },
  ];

  const cardW = (W - 20) / 3, cardH = 126;

  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Practical Nonlinear Vibration Systems</div>
      <svg viewBox={`0 0 ${W} 264`} style={{ width: '100%', display: 'block' }}>
        {systems.map(({ title, col, bg, bc, icon, lines }, i) => {
          const c = i % 3, r = Math.floor(i / 3);
          const x = 8 + c * (cardW + 3), y = 8 + r * (cardH + 6);
          return (
            <g key={i}>
              <rect x={x} y={y} width={cardW} height={cardH} rx={5} fill={bg} stroke={bc} strokeWidth="1.5" />
              <rect x={x} y={y} width={cardW} height={26} rx={4} fill={bc} />
              <text x={x + cardW / 2 - 10} y={y + 17} textAnchor="middle" fontSize="11.5" fill="#fff" fontWeight="700">{title.replace('\n', ' ')}</text>
              <text x={x + cardW - 10} y={y + 20} textAnchor="end" fontSize="18" fill="#fff" opacity="0.25">{icon}</text>
              {lines.map((line, li) => (
                <text key={li} x={x + 8} y={y + 40 + li * 17} fontSize="9.5" fill="#333"
                  fontFamily={line.includes("'") || line.includes('=') ? "'Courier New',monospace" : 'inherit'}>{line}</text>
              ))}
            </g>
          );
        })}
      </svg>
      <div style={S.dCaption}>Nonlinear vibration manifests in many practical engineering contexts. The large-amplitude pendulum has an amplitude-dependent period governed by elliptic integrals. Gear backlash creates a bilinear stiffness with a dead zone where no force is transmitted, leading to rattling and chaos under certain conditions. Structural (hysteretic) damping dissipates energy through material yielding cycles, captured by the Bouc-Wen model. Dry (Coulomb) friction introduces amplitude-dependent damping and can cause stick-slip limit cycles. Fluid-elastic instability (flutter, galloping) is a self-excited Hopf bifurcation where aerodynamic forces provide negative damping. The nonlinear energy sink (NES) exploits purely nonlinear coupling for broadband vibration absorption without a fixed resonance frequency.</div>
    </div>
  );
}

// ── Diagram 9: Stability Maps and Parameter Plane ─────────────────
function DiagramStabilityMap() {
  const W = 900, H = 330;
  const PW = (W - 30) / 2;

  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Stability Maps — Parametric Resonance (Mathieu) and Fold/Hopf Bifurcations</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{ width: '100%', display: 'block' }}>
        <defs>
          <marker id="sm1" markerWidth="6" markerHeight="6" refX="5" refY="3" orient="auto">
            <polygon points="0 0,6 3,0 6" fill="#888" />
          </marker>
        </defs>

        {/* Panel 1: Mathieu stability chart */}
        <rect x={10} y={10} width={PW} height={H - 20} rx={5} fill="#fff" stroke="#f0cece" />
        <text x={10 + PW / 2} y={28} textAnchor="middle" fontSize="13" fill="#7B0D0D" fontWeight="700">Mathieu Stability Diagram</text>
        <text x={10 + PW / 2} y={42} textAnchor="middle" fontSize="10" fill="#555">x'' + (δ + ε cos 2t)x = 0  — parametric resonance</text>

        {(() => {
          const ox = 14, oy = 60, ow = PW - 28, oh = 220;
          const deltaMax = 3.5, epsMax = 2.0;
          const toXm = d => ox + (d / deltaMax) * ow;
          const toYm = e => oy + oh - (e / epsMax) * oh;

          // Stability boundaries (approximate)
          // First tongue: centered at δ=0.25, second at δ=1, third at δ=2.25
          const tongues = [
            { delta0: 0.25, width: d => 0.35 * d + 0.02 },
            { delta0: 1.0,  width: d => 0.18 * d + 0.01 },
            { delta0: 2.25, width: d => 0.11 * d + 0.005 },
          ];

          return (
            <>
              {/* Stable region background */}
              <rect x={ox} y={oy} width={ow} height={oh} fill="#f0fff4" opacity="0.5" />
              <text x={ox + ow * 0.6} y={oy + oh * 0.6} textAnchor="middle" fontSize="11"
                fill="#27ae60" fontWeight="700" opacity="0.5">STABLE</text>

              {/* Instability tongues */}
              {tongues.map(({ delta0, width }, ti) => {
                const epsVals = Array.from({ length: 50 }, (_, i) => i / 49 * epsMax);
                const leftPts = epsVals.map(e => `${toXm(delta0 - width(e))},${toYm(e)}`).join(' ');
                const rightPts = epsVals.slice().reverse().map(e => `${toXm(delta0 + width(e))},${toYm(e)}`).join(' ');
                return (
                  <g key={ti}>
                    <polygon points={leftPts + ' ' + rightPts}
                      fill="#c0392b" opacity={0.18 + ti * 0.04} stroke="none" />
                    <polyline points={leftPts} fill="none" stroke="#c0392b" strokeWidth="1.5" />
                    <polyline points={epsVals.map(e => `${toXm(delta0 + width(e))},${toYm(e)}`).join(' ')}
                      fill="none" stroke="#c0392b" strokeWidth="1.5" />
                    <text x={toXm(delta0)} y={oy + 18} textAnchor="middle" fontSize="9"
                      fill="#c0392b" fontWeight="700">δ={delta0}</text>
                  </g>
                );
              })}

              {/* Axes */}
              <line x1={ox} y1={oy + oh} x2={ox + ow + 8} y2={oy + oh} stroke="#888" strokeWidth="1.5" markerEnd="url(#sm1)" />
              <line x1={ox} y1={oy + oh} x2={ox} y2={oy - 8} stroke="#888" strokeWidth="1.5" markerEnd="url(#sm1)" />
              {[0, 1, 2, 3].map(d => (
                <g key={d}>
                  <line x1={toXm(d)} y1={oy + oh} x2={toXm(d)} y2={oy + oh + 4} stroke="#bbb" strokeWidth="1" />
                  <text x={toXm(d)} y={oy + oh + 14} textAnchor="middle" fontSize="9" fill="#aaa">{d}</text>
                </g>
              ))}
              {[0, 0.5, 1.0, 1.5, 2.0].map(e => (
                <g key={e}>
                  <line x1={ox} y1={toYm(e)} x2={ox + 4} y2={toYm(e)} stroke="#bbb" strokeWidth="1" />
                  <text x={ox - 4} y={toYm(e) + 4} textAnchor="end" fontSize="9" fill="#aaa">{e}</text>
                </g>
              ))}
              <text x={ox + ow / 2} y={oy + oh + 26} textAnchor="middle" fontSize="10" fill="#555">δ (natural freq. parameter)</text>
              <text x={ox - 24} y={oy + oh / 2} fontSize="9.5" fill="#555" transform={`rotate(-90,${ox - 24},${oy + oh / 2})`} textAnchor="middle">ε (parametric excitation amp)</text>

              {/* Unstable label */}
              <text x={toXm(0.25)} y={oy + oh * 0.4} textAnchor="middle" fontSize="9"
                fill="#c0392b" opacity="0.7">UNSTABLE</text>
            </>
          );
        })()}

        {/* Panel 2: Bifurcation types */}
        <rect x={PW + 20} y={10} width={PW} height={H - 20} rx={5} fill="#fff" stroke="#f0cece" />
        <text x={PW + 20 + PW / 2} y={28} textAnchor="middle" fontSize="13" fill="#7B0D0D" fontWeight="700">Bifurcation Types in Nonlinear Vibrations</text>

        {[
          { y: 40, col: '#c0392b', bg: '#FEF0F0', bc: '#c0392b',
            title: 'Saddle-Node (Fold) Bifurcation',
            lines: ['Two equilibria annihilate/create at a parameter value', 'Causes jump phenomenon in Duffing oscillator', 'System snaps to distant attractor — discontinuous change', 'Hysteresis: different paths for increasing/decreasing param'] },
          { y: 128, col: '#2E75B6', bg: '#eaf3ff', bc: '#2E75B6',
            title: 'Hopf Bifurcation',
            lines: ['Equilibrium loses stability → limit cycle appears', 'Supercritical: small stable limit cycle grows smoothly', 'Subcritical: large unstable limit cycle shrinks to point', 'Controls onset of flutter, self-excited vibration'] },
          { y: 216, col: '#27ae60', bg: '#f0fff4', bc: '#27ae60',
            title: 'Pitchfork Bifurcation',
            lines: ['Symmetric system: one solution splits into three', 'Supercritical: new stable branches (buckling post-bifurcation)', 'Subcritical: new unstable branches (imperfection sensitive)', 'Seen in beams, plates under in-plane loading'] },
        ].map(({ y, col, bg, bc, title, lines }) => (
          <g key={y}>
            <rect x={PW + 26} y={y} width={PW - 14} height={lines.length * 18 + 20} rx={3} fill={bg} stroke={bc} strokeWidth="1.2" />
            <text x={PW + 32} y={y + 15} fontSize="11" fill={col} fontWeight="700">{title}</text>
            {lines.map((line, li) => (
              <text key={li} x={PW + 32} y={y + 30 + li * 18} fontSize="9.5" fill="#333">{line}</text>
            ))}
          </g>
        ))}
      </svg>
      <div style={S.dCaption}>The Mathieu equation governs parametrically excited systems — those whose stiffness varies periodically with time (e.g. a pendulum with oscillating pivot, or a beam under pulsating axial load). The stability chart shows triangular instability tongues emanating from δ = n²/4 (n = 1, 2, 3...). Within a tongue, small perturbations grow exponentially. Bifurcations are qualitative changes in system behaviour as a parameter varies: saddle-node bifurcations cause jumps; Hopf bifurcations create limit cycles; pitchfork bifurcations create symmetry-breaking. Identifying which bifurcation type is present immediately reveals the expected behaviour and the appropriate mitigation strategy.</div>
    </div>
  );
}

// ── Main ─────────────────────────────────────────────────────────
export default function NonlinearVibrations() {
  return (
    <div style={S.wrapper}>
      <h1 style={S.h1}>Nonlinear Vibrations</h1>
      <p style={S.p}>
        Nonlinear vibrations arise whenever the assumptions of linear analysis break down — when displacements are large, when restoring forces are not proportional to displacement, when damping depends on velocity or amplitude, or when the system has clearances, contacts, or fluid interactions. The consequences are profound: frequency depends on amplitude, multiple stable responses can coexist, new frequencies appear in the output that are absent from the input, and apparently simple systems can produce unpredictable chaotic motion. Understanding nonlinear vibrations is essential for any machine or structure operating beyond the small-amplitude regime.
      </p>

      <InfoBox title="Core Ideas at a Glance" items={[
        "Nonlinear systems violate superposition: outputs are not proportional to inputs and frequencies interact",
        "Hardening nonlinearity: resonance frequency increases with amplitude (Duffing+ type) — curve bends right",
        "Softening nonlinearity: resonance frequency decreases with amplitude (Duffing− type) — curve bends left",
        "Jump phenomenon: two stable amplitudes coexist between the jump frequencies; hysteresis on sweep up vs. down",
        "Backbone curve: locus of free-vibration amplitude vs. natural frequency — reveals nonlinearity type and strength",
        "Limit cycles: self-sustained oscillations with fixed amplitude regardless of initial conditions (Van der Pol)",
        "Superharmonics (3ω, 5ω from cubic x³) and subharmonics (ω/2, ω/3) generated by nonlinearity",
        "Bifurcations: qualitative changes in system behaviour — saddle-node (jump), Hopf (limit cycle), period-doubling (chaos)",
        "Feigenbaum constant δ ≈ 4.669: universal ratio of bifurcation spacings in period-doubling route to chaos",
        "Lyapunov exponent λ > 0: definitive test for chaos (exponential divergence of nearby trajectories)",
      ]} />

      <h2 style={S.h2}>Restoring Forces and Potential Wells</h2>
      <p style={S.p}>
        The character of a nonlinear system is encoded in its restoring force characteristic F(x). Linear systems have F = kx — a straight line through the origin. Any deviation from linearity fundamentally changes the dynamics. The potential energy well V(x) = −∫F dx provides geometric insight into equilibria, stability, and the energy required to transition between coexisting states.
      </p>
      <DiagramRestoringForces />
      <Table2 rows={[
        ["Duffing equation", "x'' + 2ζωₙx' + ωₙ²x + εαx³ = F₀cos ωt\nεα {'>'} 0: hardening — stiffness increases with displacement\nεα {'<'} 0: softening — stiffness decreases with displacement\nεα = 0: linear SDOF (recovered)"],
        ["Hardening stiffness", "Physical sources: geometric stiffening (cables, membranes), contact mechanics\nEffect: resonance frequency increases with amplitude\nFrequency response curve bends right; jump-up at higher frequency"],
        ["Softening stiffness", "Physical sources: pendulum (sin θ ≈ θ − θ³/6), magnetic springs, pre-buckled beams\nEffect: resonance frequency decreases with amplitude\nFrequency response curve bends left; jump-down at lower frequency"],
        ["Bilinear stiffness", "Different stiffness in tension vs. compression, or with a dead zone (clearance)\nSources: gear backlash, loose joints, preloaded contacts\nGenerates even and odd superharmonics; common cause of gear rattle"],
        ["Double-well potential", "V(x) = −x²/2 + x⁴/4  →  two stable equilibria at x = ±1\nUnstable equilibrium at x = 0 (local maximum of V)\nSmall oscillations: trapped in one well (linear-like)\nLarge energy: cross-well chaotic motion"],
        ["Dead-band (backlash)", "Zero restoring force for |x| {'<'} δ/2  (clearance half-gap)\nModels gear teeth, bolted joints, loose fit bearings\nEnergy loss per cycle: 4F_contact·δ (rectangular loop area)\nCauses sudden contact impacts — impulsive forces"],
      ]} />

      <h2 style={S.h2}>Duffing Oscillator and Jump Phenomenon</h2>
      <p style={S.p}>
        The Duffing equation is the canonical model of nonlinear vibration. Its frequency-response curve is a leaning resonance peak that creates a multi-valued region where three amplitudes are possible at a single frequency — two stable and one unstable. As the forcing frequency is slowly swept, the response follows one branch until it reaches a fold point and jumps discontinuously to the other branch. This jump phenomenon is irreversible and hysteretic.
      </p>
      <DiagramDuffing />
      <Table2 rows={[
        ["Backbone curve formula", "From Lindstedt-Poincaré: ω_backbone² = ωₙ²(1 + 3εα a²/(4ωₙ²))\nSlope of lean = 3εα/(8ωₙ) in amplitude-frequency plane\nIntersects linear peak at a = 0; diverges for larger a"],
        ["Jump-up frequency", "ω_jump-up = ωₙ√(1 + 3εα a_peak²/(4ωₙ²))  ≈ ωₙ + 3εα a_peak²/(8ωₙ)\nSystem on lower stable branch; amplitude suddenly jumps to upper branch\nFrequency at which lower branch fold occurs"],
        ["Jump-down frequency", "ω_jump-down {'<'} ω_jump-up (hardening), {'>'} for softening\nSystem on upper stable branch; amplitude suddenly drops to lower branch\nHysteresis bandwidth = ω_jump-up − ω_jump-down"],
        ["Stability of branches", "Tested by Jacobian of amplitude equations (multiple scales)\nUpper branch: stable (dA/dr {'<'} 0 — amplitude decreases as r increases)\nMiddle branch: unstable (saddle point in amplitude-phase plane)\nLower branch: stable"],
        ["Effect of damping ζ", "Increasing ζ reduces peak amplitude, narrows hysteresis band\nAt critical ζ_cr: hysteresis band vanishes, curve becomes single-valued\nζ_cr ≈ (3εα F₀²/ωₙ⁶)^(1/3) / (3√3) — function of nonlinearity and force level"],
        ["Superharmonic resonance", "Excite at ω ≈ ωₙ/3: third superharmonic 3ω coincides with natural frequency\nLarge response even though ω is far from ωₙ\nCommon problem in hardening systems excited at sub-critical speeds"],
      ]} />

      <h2 style={S.h2}>Phase Plane and Limit Cycles</h2>
      <p style={S.p}>
        The phase plane is the most powerful geometric tool for nonlinear dynamics. It visualises the complete state space of a second-order system, showing not just one trajectory but the global structure of all possible behaviours. Attractors — the long-time destinations of trajectories — can be equilibrium points, limit cycles, or the fractal strange attractors of chaotic systems.
      </p>
      <DiagramPhasePlane />
      <Table2 rows={[
        ["Equilibrium classification", "Eigenvalues of linearised Jacobian at equilibrium determine local behaviour:\nBoth negative real: stable node (overdamped)\nComplex with negative real part: stable spiral (underdamped)\nPurely imaginary: centre (conservative nonlinear oscillator)\nOne positive, one negative real: saddle point (unstable)"],
        ["Limit cycle", "Isolated closed orbit in phase plane — periodic solution\nStable limit cycle: all nearby trajectories converge to it\nUnstable limit cycle: all nearby trajectories diverge from it\nSelf-sustained oscillation with fixed amplitude regardless of initial conditions"],
        ["Van der Pol oscillator", "x'' − μ(1−x²)x' + x = 0\nμ {'>'} 0: negative damping for |x| {'<'} 1 (energy input), positive for |x| {'>'} 1 (energy drain)\nBalances to give stable limit cycle of amplitude ≈ 2\nModels: electrical oscillators, neural oscillations, heart rhythm"],
        ["Isoclines method", "Find curves where dx/dt = 0 (horizontal isoclines) and dẋ/dt = 0 (vertical isoclines)\nIntersections are equilibria; isoclines guide trajectory direction\nQuick qualitative sketch without solving equations"],
        ["Potential and Hamiltonian", "Conservative system (no damping): H(x,p) = T + V = constant\nTrajectories are contours of H in phase space (closed curves)\nWith damping: H decreases along trajectory — spiral toward attractor\nSaddle connections (heteroclinic orbits) separate basins of attraction"],
        ["Basin of attraction", "Set of all initial conditions that converge to a given attractor\nFor multiple attractors: basins are separated by invariant manifolds\nFractal basin boundaries: sensitivity to initial conditions near boundary\nPractical importance: small perturbation near boundary → unpredictable outcome"],
      ]} />

      <h2 style={S.h2}>Nonlinear Frequency Content</h2>
      <p style={S.p}>
        One of the clearest experimental signatures of nonlinearity is the presence of frequencies in the response that are not present in the input. When a nonlinear system is excited at frequency ω, the output contains ω plus its harmonics and subharmonics. The pattern of generated frequencies is a direct fingerprint of the type of nonlinearity.
      </p>
      <DiagramFrequencyContent />
      <Table2 rows={[
        ["Superharmonics", "Frequencies nω (n = 2, 3, 4,...) in response to single-frequency input at ω\nOdd nonlinearity (x³): generates 3ω, 5ω, ... (odd multiples)\nEven nonlinearity (x²): generates 2ω, 4ω, ... plus DC shift\nAmplitude: nth superharmonic ∝ εⁿ (decreasing with order)"],
        ["Subharmonics", "Frequencies ω/n in response to excitation at ω\nRequire frequency-to-amplitude relationship to satisfy resonance condition\nω/2 (period-2): common via period-doubling bifurcation\nω/3 (period-3): implies chaos exists nearby (Sharkovskii)\nRequire finite amplitude threshold to exist — supercritical"],
        ["Combination frequencies", "MDOF nonlinear systems: frequencies nω₁ ± mω₂ (n,m integers)\nSum/difference tones: f₁+f₂, f₁−f₂, 2f₁−f₂, ...\nCommon in gearboxes: gear mesh + shaft harmonics mix\nIdentified in spectrum as rational linear combinations of input frequencies"],
        ["Quasi-periodic motion", "Two incommensurate frequencies ω₁ and ω₂ (ω₁/ω₂ irrational)\nTime record never exactly repeats; power spectrum: two independent lines\nPoincaré map: closed curve (torus attractor)\nDistinct from chaos: bounded, no positive Lyapunov exponent"],
        ["Describing function", "Approximate fundamental response amplitude to sinusoidal input:\nN(a) = (1/πa)∫₋π^π f(a sin θ) e^(jθ) dθ\nReplaces nonlinear element with equivalent complex gain N(a)\nPredicts limit cycles where 1 + N(a)G(jω) = 0"],
        ["Spectral analysis for NL detection", "Measure coherence function γ²(ω): drops below 1 if nonlinear\nHigher-order spectra (bispectrum): detects quadratic coupling\nTransmissibility across frequency: nonlinear if frequency-dependent at constant amp\nRec.: measure FRF at multiple force levels — linear if FRF unchanged"],
      ]} />

      <h2 style={S.h2}>Bifurcation and Period-Doubling Route to Chaos</h2>
      <p style={S.p}>
        A bifurcation is a qualitative change in the long-term behaviour of a system as a parameter is continuously varied. The period-doubling route to chaos — first discovered by Feigenbaum — is one of the most universal pathways: a stable period-1 orbit becomes period-2, then period-4, then period-8, in a cascade that converges geometrically to chaos at a parameter value governed by the universal constant δ ≈ 4.669.
      </p>
      <DiagramBifurcation />
      <Table2 rows={[
        ["Period-doubling bifurcation", "A stable period-T orbit becomes unstable and splits into a period-2T orbit\nOccurs at specific parameter values r₁, r₂, r₃, ...\nSpacing: (rₙ−rₙ₋₁)/(rₙ₊₁−rₙ) → δ ≈ 4.6692 (Feigenbaum constant)\nInfinite cascade converges to chaos at r_∞"],
        ["Feigenbaum universality", "δ ≈ 4.669 and α ≈ 2.503 are the same for ALL 1D maps with a quadratic maximum\nApplies to Duffing oscillator, logistic map, dripping faucet, nonlinear circuits\nUniversality: the route to chaos is the same regardless of system details\nEnabled experimental prediction of chaos in fluid, optical, and mechanical systems"],
        ["Identifying period from data", "Period-n orbit: Poincaré map has exactly n fixed points\nTime record: ratio T_response/T_forcing = n (integer)\nFrequency spectrum: spectral lines at ω/n, 2ω/n, ..., ω\nPeriod-doubling detected: new lines at half-integer multiples of forcing frequency"],
        ["Intermittency route to chaos", "Laminar phases interrupted by chaotic bursts of increasing duration\nType I: saddle-node bifurcation (period-3 appears)\nType II: Hopf bifurcation of a periodic orbit\nType III: sub-critical period-doubling\nAll three types have universal statistical scaling of burst duration"],
        ["Quasiperiodic route", "Frequency-locking and Arnold tongues in two-frequency systems\nRational ω₁/ω₂ = p/q: frequency-locked (periodic) — Arnold tongue\nIrrational ratio: quasi-periodic → can transition to chaos via torus breakdown\nSeen in coupled oscillators, Faraday waves"],
        ["Chaos vs. noise", "Chaos: deterministic, bounded, positive Lyapunov exponent, fractal attractor\nNoise: stochastic, infinite-dimensional, no attractor structure\nBroadband spectrum alone is NOT sufficient to identify chaos\nRequire: phase-space reconstruction, Lyapunov exponent, correlation dimension"],
      ]} />

      <h2 style={S.h2}>Poincaré Maps and Strange Attractors</h2>
      <p style={S.p}>
        The Poincaré map converts the continuous flow of a dynamical system into a discrete-time map by sampling the state at regular intervals. It is the most powerful numerical tool for identifying the type of motion — periodic, quasi-periodic, or chaotic — and for visualising the geometric structure of attractors in higher-dimensional phase spaces.
      </p>
      <DiagramPoincareAttractor />
      <Table2 rows={[
        ["Poincaré section construction", "Choose a surface of section S in state space (e.g. ẋ = 0, x {'>'} 0)\nRecord state x each time trajectory crosses S in same direction\nPeriodic: finite set of n points (period-n orbit)\nQuasi-periodic: dense closed curve\nChaotic: strange fractal set"],
        ["Fixed points of Poincaré map", "Period-n orbit in continuous system ↔ period-n fixed point of Poincaré map\nStability: eigenvalues of Jacobian Df^n at fixed point\n|eigenvalue| {'<'} 1: stable  |eigenvalue| {'>'} 1: unstable\nFlip bifurcation (eigenvalue = −1): period-doubling"],
        ["Strange attractor properties", "Bounded in phase space (dissipative system)\nSensitive dependence on initial conditions (positive λ_max)\nFractal geometric structure (non-integer dimension)\nInvariant under the flow (trajectories stay on attractor)\nExamples: Lorenz, Rössler, Hénon map"],
        ["Lyapunov exponents spectrum", "n-dimensional system: n Lyapunov exponents λ₁ ≥ λ₂ ≥ ... ≥ λₙ\nChaos: λ₁ {'>'} 0 (at least one positive)\nKaplan-Yorke dimension: d_KY = j + Σᵢ₌₁ʲ λᵢ / |λⱼ₊₁|  (j: index where sum changes sign)\nConserves: Σλᵢ = divergence of vector field (negative for dissipative)"],
        ["Reconstruction from data", "Takens embedding theorem: embed scalar data x(t) in d-dimensional space\nDelay coordinates: [x(t), x(t+τ), x(t+2τ), ...]\nChoose τ: first zero of autocorrelation or first minimum of mutual information\nChoose d: false nearest neighbours; d_embed = 2d_attractor + 1"],
        ["Numerical integration methods", "Runge-Kutta 4: standard for smooth nonlinear ODEs (dt ≤ period/100)\nAdaptive step: variable dt for stiff or impacting systems\nEvent detection: for impacts, zero crossings (gear backlash, contact)\nVariational equations: needed for Lyapunov exponent computation"],
      ]} />

      <h2 style={S.h2}>Analytical Methods</h2>
      <p style={S.p}>
        Exact closed-form solutions are almost never available for nonlinear vibration problems. Instead, approximate analytical methods provide insight into the amplitude-frequency relationship, stability, and parameter dependence — results that numerical simulation alone cannot give. All methods are valid for small nonlinearity (ε ≪ 1) but provide complementary perspectives.
      </p>
      <DiagramPerturbation />
      <Table2 rows={[
        ["Regular perturbation (failure)", "Naive expansion x = x₀ + εx₁ + ε²x₂ +... substituted into EOM\nFor Duffing: x₁ term contains cos(ωₙt)·t (secular term — grows unbounded)\nPhysical meaning: the perturbation shifts the frequency, not just the amplitude\nCure: simultaneously expand the frequency (Lindstedt) or use multiple scales"],
        ["Lindstedt-Poincaré summary", "x = x₀ + εx₁;  ω² = ωₙ² + εω₂ + ...\nChoose ω₂ to eliminate secular terms at each order\nResult: ω = ωₙ√(1 + 3εα a²/4ωₙ²) — the backbone curve\nAccuracy: O(ε²); valid for ε a²/ωₙ² ≪ 1"],
        ["Multiple scales summary", "Fast time T₀ = t, slow time T₁ = εt\nZeroth order: harmonic oscillator; First order: secular condition\nYields modulation equations for complex amplitude A(T₁)\nSteady state: |A|= a/2; sweep → full nonlinear frequency-response curve"],
        ["Harmonic balance summary", "Assume N-term Fourier series; substitute; collect coefficients\nN=1 (first harmonic): gives Duffing backbone curve\nN=3: includes 3ω correction to amplitude and frequency\nCan handle strong nonlinearity (ε not small) with enough harmonics"],
        ["Numerical continuation", "AUTO, MatCont, COCO: trace solution branches as parameter varies\nDetects fold, Hopf, period-doubling, torus bifurcations automatically\nFollows unstable branches (not accessible by time simulation)\nProduces full bifurcation diagram including unstable middle branch of Duffing"],
        ["Energy-based methods", "Equivalent linearisation: replace nonlinear system with linear one of same energy\nk_eq = E[F(x)x]/E[x²]  (statistical linearisation for random input)\nDissipated energy/cycle = πcω a² (viscous) or 4μN (Coulomb)\nEnergy balance at limit cycle: energy input = energy dissipated → find amplitude a"],
      ]} />

      <h2 style={S.h2}>Practical Nonlinear Systems</h2>
      <p style={S.p}>
        Nonlinear vibration is not just a theoretical curiosity — it governs the behaviour of real engineering systems across many domains. Recognising the type of nonlinearity present in a system is the first step toward predicting and controlling its response.
      </p>
      <DiagramPracticalSystems />
      <Table2 rows={[
        ["Large-amplitude pendulum", "θ'' + (g/L) sin θ = 0;   sin θ ≈ θ − θ³/6 + ...\nExact period: T = 4√(L/g) K(sin(θ₀/2))  (K = complete elliptic integral)\nFor θ₀ = 90°: T/T_linear ≈ 1.18 (18% longer)\nIsochrone only for θ₀ → 0; softening-type nonlinearity"],
        ["Rub and impact oscillator", "x'' + 2ζωₙx' + ωₙ²x = F cos ωt;  impact when x = Δ (clearance)\nNewton restitution: ẋ_after = −r·ẋ_before at contact (r = coefficient of restitution)\nPeriodic, quasi-periodic, and chaotic orbits all possible\nPoincaré map: stroboscopic or impact-triggered"],
        ["Hysteretic (Bouc-Wen) model", "Restoring force: f_R = αkx + (1−α)kz\nz satisfies: dz/dt = Aẋ − β|ẋ||z|^(n−1)z − γẋ|z|^n\nParameters A, β, γ, n control shape, area, and pinching of hysteresis loop\nUsed in earthquake engineering, rubber bearings, smart material actuators"],
        ["Friction-induced vibration", "Stick-slip oscillation: Stribeck effect (friction decreases with velocity near zero)\nNegative slope of friction curve → negative damping → growing oscillations\nLimit cycle amplitude set by positive damping at higher velocity\nExamples: brake squeal, violin bow, cutting tool chatter, earthquake fault slip"],
        ["Parametric excitation (Mathieu)", "x'' + (δ + ε cos 2t) x = 0;  stiffness varies periodically\nPrincipal parametric resonance: excitation at 2ωₙ → exponential growth\nStability boundaries: Mathieu tongues in (δ, ε) plane\nSources: rotating shaft with asymmetric cross-section, cable under pulsating tension"],
        ["Nonlinear energy harvesting", "Purposeful use of nonlinearity to broaden harvesting bandwidth\nBistable harvester: snap-through between wells captures low-amplitude vibration\nNonlinear magnetic coupling: adjustable effective stiffness\nDuffing-type harvester: wider bandwidth than linear at same mass"],
      ]} />

      <h2 style={S.h2}>Stability Maps and Bifurcation Types</h2>
      <p style={S.p}>
        Stability maps provide a global view of how system behaviour changes across the parameter space. The Mathieu stability diagram is the classic example for parametrically excited systems. Bifurcation theory classifies all possible qualitative changes in system behaviour and provides the mathematical framework for understanding why and how systems transition between different response types.
      </p>
      <DiagramStabilityMap />
      <Table2 rows={[
        ["Mathieu equation", "x'' + (δ + ε cos 2t) x = 0\nδ = (ωₙ/Ω)²: ratio of natural to excitation frequency squared\nε: amplitude of parametric excitation\nInstability tongues at δ = n² (n = 0, 1/2, 1, 3/2, 2, ...)"],
        ["Principal parametric resonance", "Strongest instability at δ = 1 (ωₙ = Ω, excitation at twice natural freq)\nInstability threshold: ε_cr ≈ 2ζ (damping raises threshold)\nExponential growth until nonlinearity limits amplitude\nPractical: rotating shaft orbits, cable vibration under pulsating tension"],
        ["Hopf bifurcation", "Equilibrium has eigenvalues ±jω (purely imaginary) at bifurcation point\nSupercritical: small amplitude stable limit cycle emerges\nSubcritical: unstable limit cycle shrinks to zero — hard excitation needed\nNormal form: r' = μr − r³ (supercritical) or r' = μr + r³ (subcritical)"],
        ["Saddle-node bifurcation", "Two equilibria collide and annihilate (or emerge from nothing)\nCauses fold point in frequency-response curve → jump phenomenon\nCatastrophic (non-smooth) transition — no warning before jump\nHysteresis: different jump frequencies for up and down sweeps"],
        ["Transcritical bifurcation", "Two branches of equilibria exchange stability\nNeither stable equilibrium can disappear — one becomes the other\nCommon in population dynamics; rare in mechanical vibrations\nCan occur in asymmetric systems where symmetry-breaking is imperfect"],
        ["Normal form theory", "Near a bifurcation, behaviour captured by lowest-order polynomial\nSaddle-node: x' = μ + x²  (only one parameter matters)\nHopf: r' = μr − r³ (in polar coordinates)\nPitchfork: x' = μx − x³\nCenter manifold reduction: high-dim system → low-dim normal form near bifurcation"],
      ]} />

      <InfoBox title="Key Formulae Summary" items={[
        "Duffing EOM: x'' + 2ζωₙx' + ωₙ²x + εαx³ = F₀cos ωt",
        "Backbone curve: ω² = ωₙ²(1 + 3εα a² / 4ωₙ²)  — from Lindstedt-Poincaré",
        "Van der Pol: x'' − μ(1−x²)x' + x = 0;  limit cycle amplitude ≈ 2 for all μ > 0",
        "Describing function: 1 + N(a)G(jω) = 0  gives limit cycle conditions (N(a) = amplitude-dependent gain)",
        "Lyapunov exponent: λ = lim(1/t) ln|δx(t)/δx₀| ;  chaos ⟺ λ > 0",
        "Feigenbaum: (rₙ−rₙ₋₁)/(rₙ₊₁−rₙ) → δ ≈ 4.6692  (universal period-doubling constant)",
        "Mathieu: x'' + (δ + ε cos 2t)x = 0;  unstable at δ ≈ n²/4  (n = 1,2,3...)",
        "Log decrement (nonlinear): δₙ = ln(aₙ/aₙ₊₁);  ζ_eff = δₙ/(2π) may vary with amplitude",
      ]} />
    </div>
  );
}